'use client'

import * as PopoverPrimitive from '@radix-ui/react-popover'
import { menuDataStateAnimationCls } from 'helpers'
import * as React from 'react'
import { cn } from 'utils/cn'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef<
	React.ElementRef<typeof PopoverPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(
	(
		{
			className = 'w-[177px] max-w-[177px]',
			align = 'end',
			side = 'bottom',
			sideOffset = 7,
			collisionPadding = 10,
			...props
		},
		ref,
	) => (
		<PopoverPrimitive.Portal>
			<PopoverPrimitive.Content
				ref={ref}
				align={align}
				side={side}
				sideOffset={sideOffset}
				collisionPadding={collisionPadding}
				className={cn(
					'rounded-8 bg-white p-4 shadow-generator',
					menuDataStateAnimationCls,
					className,
				)}
				{...props}
			/>
		</PopoverPrimitive.Portal>
	),
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger }
